import { useCallback } from 'react';
import { Button, Divider, Grid, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useInterviewLandingPage } from '../InterviewLandingPage/useInterviewLandingPage';
import Icon from '../../../components/ui-components/Icon';
import LeftArrowWhite from '../../../assets/images/arrow-left-white.svg';
import LeftArrow from '../../../assets/images/arrow-left.svg';
import RightArrowWhite from '../../../assets/images/arrow-right-white.svg';
import { FUNCTIONARY_HOME, PRE_WORK_INTERVIEW } from '../../../shared/Routes';
import { useBatchId } from '../../../hooks/useBatchId';
import { ApplicantDetailsTable } from '../ApplicantDetailsTable';

const { Text } = Typography;
const { useBreakpoint } = Grid;

const SectionHeader = ({
	heading,
	onBackClick,
	isMobile,
}: {
	heading: string;
	onBackClick: () => void;
	isMobile: boolean;
}) => {
	const { t } = useTranslation();

	return (
		<div className="relative flex items-center justify-between mb-4 py-2">
			{isMobile ? (
				<div onClick={onBackClick}>
					<Icon src={LeftArrow} width={20} height={20} />
				</div>
			) : (
				<Button
					type="primary"
					onClick={onBackClick}
					icon={<Icon src={LeftArrowWhite} width={'w-4'} height={'h-4'} />}
					className="absolute font-bold text-sm left-0"
				>
					{t('back')}
				</Button>
			)}
			<Text className="flex-grow text-center font-sans font-bold text-lg text-secondary-black">
				{heading}
			</Text>
		</div>
	);
};

export const PreworkMentorContextPage = () => {
	const { t } = useTranslation();
	const { application, navigateToPage } = useInterviewLandingPage();
	const { navigateWithBatchId } = useBatchId();
	const screens = useBreakpoint();
	const isMobile = !screens.sm;

	const handleBackClick = useCallback(() => {
		navigateWithBatchId(FUNCTIONARY_HOME);
	}, [navigateWithBatchId]);

	return (
		<div className="flex justify-center">
			<div
				className={`flex flex-col h-full min-h-0 p-[8px] ${
					isMobile ? 'w-full' : 'w-[90%]'
				}`}
			>
				<SectionHeader
					heading={t('preworkInterview')}
					onBackClick={handleBackClick}
					isMobile={isMobile}
				/>
				<ApplicantDetailsTable applicantInfo={application.applicant} />

				<div className="flex justify-center">
					<div
						className={`flex flex-col items-center bg-white p-4 rounded-lg shadow-md my-4 ${
							!isMobile ? 'w-3/4' : 'w-full'
						}`}
					>
						<Text className="text-base font-semibold text-center mt-2 text-secondary-black">
							{t('setContextPolitely')}
						</Text>
						<Divider className="border border-solid border-gray-200" />
						<div className="font-sans font-semibold text-sm text-gray-650 px-4">
							<p className="font-extrabold">
								{t('dearPreworkMentor')}
								{','}
							</p>
							<p>{t('preworkMentorContextContent')}</p>
						</div>
						<div
							className={`flex ${
								!isMobile ? 'justify-end' : 'justify-center'
							} w-full gap-2 mt-4`}
						>
							<Button
								onClick={() => navigateToPage(FUNCTIONARY_HOME)}
								className="font-bold text-sm"
							>
								{t('cancel')}
							</Button>
							<Button
								type="primary"
								onClick={() => navigateToPage(PRE_WORK_INTERVIEW)}
								className="font-bold text-sm"
							>
								{t('next')}{' '}
								<Icon src={RightArrowWhite} width={'w-5'} height={'h-5'} />
							</Button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
